import { lockScroll, unlockScroll } from "../../@helpers";
import Navigation from "../Navigation";
import React, { Component, Fragment } from "react";
import "./style.scss";
export default class extends Component {
  constructor() {
    super();
    this.state = {
      isActive: false
    };
  }

  toggleNav = event => {
    const currentState = event.currentTarget.dataset.active;
    this.setState({
      isActive: currentState === "false" ? true : false
    });
    currentState === "false" ? lockScroll() : unlockScroll();
  };

  render() {
    const { isActive } = this.state;
    let languageSwitch;

    if (process.env.REACT_APP_LANG === "en-gb") {
      languageSwitch = (
        <div className="language-switch-container">
          <a className="language_switch" href={process.env.REACT_APP_ES_URL}>
            ESP
          </a>
          <a className="language_switch" href={process.env.REACT_APP_FR_URL}>
            FR
          </a>
          <a className="language_switch" href={process.env.REACT_APP_AR_URL}>
            AR
          </a>
        </div>
      );
    } else if (process.env.REACT_APP_LANG === "fr-fr") {
      languageSwitch = (
        <div className="language-switch-container">
          <a className="language_switch" href={process.env.REACT_APP_EN_URL}>
            ENG
          </a>
          <a className="language_switch" href={process.env.REACT_APP_AR_URL}>
            AR
          </a>
        </div>
      );
    } else if (process.env.REACT_APP_LANG === "ar-ar") {
      languageSwitch = (
        <div className="language-switch-container">
          <a className="language_switch" href={process.env.REACT_APP_EN_URL}>
            ENG
          </a>
          <a className="language_switch" href={process.env.REACT_APP_FR_URL}>
            FR
          </a>
        </div>
      );
    } else {
      languageSwitch = (
        <div className="language-switch-container">
          <a className="language_switch" href={process.env.REACT_APP_EN_URL}>
            ENG
          </a>
        </div>
      );
    }

    return (
      <Fragment>
        <header className="site-header">
          {process.env.REACT_APP_LANG === "en-gb"}
          {languageSwitch}
          <a className="company_logo" href={process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}>
            {process.env.REACT_APP_LANG === 'en-gb' && <img src="/static/logo_mth.svg" alt="More than Height" />}
            {process.env.REACT_APP_LANG === 'es-es' && <img src="/static/logo_mth_es.png" alt="More than Height" />}
            {process.env.REACT_APP_LANG === 'ar-ar' && <img src="/ar/static/logo_mth_ar.png" alt="More than Height" />}
            {process.env.REACT_APP_LANG === 'fr-fr' && <img src="/static/logo_mth_fr.png" alt="More than Height" />}
          </a>
          <div
            className="nav_toggle"
            onClick={this.toggleNav}
            data-active={isActive}
          >
            <svg
              className="hamburger"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
            </svg>
            <svg
              className="close"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </div>
          <Navigation name="primary-navigation" active={isActive} toggleTheNav={this.toggleNav} />
        </header>
      </Fragment>
    );
  }
}
